import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "invert"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Toggle } from "../Toggle";
import styles from "./styles.pcss";
var getClassName = function getClassName(type) {
  return cnBem(type, styles);
};
export var defineControl = function defineControl(type) {
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var className = _ref.className,
      invert = _ref.invert,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var cnControl = getClassName(type);
    return /*#__PURE__*/React.createElement(Toggle, _extends({}, otherProps, {
      className: cnControl({
        invert: invert
      }, [className]),
      inputClassName: cnControl('input'),
      invert: invert,
      labelClassName: cnControl('label'),
      ref: ref,
      type: type,
      "data-t-id": "components-Checkbox"
    }));
  });
};